import React from "react";
import AlertLineURLsTable from "../../../containers/AlertLineURLsTable/AlertLineURLsTable";
import { useAppSelector } from "../../../custom-hooks/redux/redux";
import { NotAuthorizedPage } from "../../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";

const AlertLineURLs = () => {
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const isAuthorized = currentUserAuthorizations?.canChangeAll || currentUserAuthorizations?.canViewAll;

  return <>{isAuthorized ? <AlertLineURLsTable /> : <NotAuthorizedPage />}</>;
};
export default AlertLineURLs;
